import * as React from 'react'
import { useTranslation } from 'react-i18next'
import type { GeneralLicenseFacilityType } from '../../../generated/types'
import {
	StyledTextBlock,
	StyledSecondaryButton,
	StyledCardSubtitle,
	StyledButtonColumn,
	StyledTextRowGrid,
	StyledCardTitle
} from './styles'
import moment from 'moment'
moment.locale('de')

// Props expected by the GeneralFacilityRow component. `facility` is the
// data object fetched from the backend via GraphQL. `onPreview` is a
// callback that will be invoked when the user clicks the "view" button
// and should open a preview of the document (PDF or HTML) associated with
// the facility.
type Props = {
	facility: GeneralLicenseFacilityType
	onPreview: (facility: GeneralLicenseFacilityType) => void
}

export const GeneralFacilityRow: React.FC<Props> = ({
	facility,
	onPreview
}) => {
	const { t } = useTranslation()

	// Determine if this facility has any previewable URL. If neither the
	// PDF nor HTML link is provided the button will be disabled so users
	// can't click an empty preview.
	const hasUrl = Boolean(facility.pdfUrl || facility.htmUrl)

	// Format the last-modified date for display, falling back to null when
	// unavailable. Using moment simplifies locale-aware formatting.
	const formattedStand = facility.lastmodifiedAt
		? moment(facility.lastmodifiedAt).format('DD.MM.YYYY')
		: null

	return (
		<StyledTextRowGrid>
			{/* text block contains title and optional published date */}
			<StyledTextBlock>
				<StyledCardTitle>{facility.title}</StyledCardTitle>

				<StyledCardSubtitle>
					{formattedStand
						? t('license.agreements.publishedDate', { date: formattedStand })
						: ''}
				</StyledCardSubtitle>
			</StyledTextBlock>

			{/* button column renders the preview action; disabled when no URL */}
			<StyledButtonColumn>
				<StyledSecondaryButton
					onClick={() => onPreview(facility)}
					disabled={!hasUrl}
				>
					{t('license.agreements.view')}
				</StyledSecondaryButton>
			</StyledButtonColumn>
		</StyledTextRowGrid>
	)
}
